module.exports = __webpack_public_path__ + "img/feynman-dark.01332f49.svg";